/**
 * Safely read a tracking id (e.g. gclid, msclkid) from localStorage
 * @param {string} key - localStorage key
 * @returns {string} - tracking id value or empty string
 */
export const getTrackingId = (key) => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return ''
    }
    const raw = window.localStorage.getItem(key)
    if (!raw) {
      return ''
    }
    const record = JSON.parse(raw)
    if (!record || typeof record !== 'object') {
      return ''
    }
    const { value, expiryDate } = record
    if (!value) {
      return ''
    }
    if (typeof expiryDate === 'number' && new Date().getTime() > expiryDate) {
      return ''
    }
    return value
  } catch (e) {
    // Swallow JSON/localStorage errors to avoid breaking the form flow
    // eslint-disable-next-line no-console
    console.error(`❌ Failed to read tracking id for key ${key}:`, e)
    return ''
  }
}

